import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-api-call-timer',
  templateUrl: './api-call-timer.component.html',
  styleUrls: ['./api-call-timer.component.css']
})
export class ApiCallTimerComponent {
  @Input() duration: number | null = null;

  constructor() { }

  get durationInSeconds(): string {
    if (this.duration === null) {
      return '';
    }
    return (this.duration / 1000).toFixed(2);
  }

  get durationInMilliseconds(): string {
    if (this.duration === null) {
      return '';
    }
    return this.duration.toFixed(0);
  }
}
